import { render } from "./NewBusinessRuleActionCreateRecord.vue?vue&type=template&id=a5d69260"
import script from "./NewBusinessRuleActionCreateRecord.vue?vue&type=script&lang=js"
export * from "./NewBusinessRuleActionCreateRecord.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__